import { useCallback, useEffect, useState } from 'react';

import { ResponsiveSize } from '~constants';

export const useMediaQuery = (mediaQuery: ResponsiveSize): boolean => {
  const [targetReached, setTargetReached] = useState(false);

  const updateTarget = useCallback((e: MediaQueryListEvent) => {
    setTargetReached(e.matches);
  }, []);

  useEffect(() => {
    const media = globalThis.matchMedia(mediaQuery);

    // Initial check
    setTargetReached(media.matches);

    const mediaListener = (e: MediaQueryListEvent) => updateTarget(e);

    media.addEventListener('change', mediaListener);

    return () => {
      media.removeEventListener('change', mediaListener);
    };
  }, [mediaQuery, updateTarget]);

  return targetReached;
};
